// src/App.jsx

import React, { useEffect } from 'react'; // <-- Import useEffect
import { AppProvider, useAppContext } from './context/AppContext';
import './index.css'; // Import global styles

// Import Components
import Header from './components/Header';
import Screen1_UserInfo from './components/Screen1_UserInfo';
import Screen2_CarType from './components/Screen2_CarType';
// NEW ranking screens
import Screen4_RankTestDrive from './components/Screen4_RankTestDrive';
import Screen5_RankDesign from './components/Screen5_RankDesign';
import Screen6_RankInterior from './components/Screen6_RankInterior';
// Renamed screens
import Screen7_Quiz from './components/Screen7_Quiz';
import Screen8_ThankYou from './components/Screen8_ThankYou';
// Removed: Screen3_CarList, Screen4_Rating

// This component conditionally renders the active screen
const AppContent = () => {
    const { currentScreen } = useAppContext();

    return (
        <div className="w-full max-w-md bg-white shadow-lg min-h-screen main_bg">
            <Header />

            {/* Conditional Screen Rendering (Updated Flow) */}
            {currentScreen === 'screen-1' && <Screen1_UserInfo />}
            {currentScreen === 'screen-2' && <Screen2_CarType />}
            
            {/* New Ranking Flow */}
            {currentScreen === 'screen-4-testdrive' && <Screen4_RankTestDrive />}
            {currentScreen === 'screen-5-design' && <Screen5_RankDesign />}
            {currentScreen === 'screen-6-interior' && <Screen6_RankInterior />}
            
            {/* Renamed Final Screens */}
            {currentScreen === 'screen-7-quiz' && <Screen7_Quiz />}
            {currentScreen === 'screen-8-thankyou' && <Screen8_ThankYou />}
        </div>
    );
}

// This is the root component that includes the Context Provider
const App = () => {
    // NEW: Clear localStorage on app load
    useEffect(() => {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('carRankings-testDrive');
        localStorage.removeItem('carRankings-design');
        localStorage.removeItem('carRankings-interior');
        console.log('Previous session cleared.');
    }, []); // Empty array ensures this runs only once on mount   

    return (
        <AppProvider>
            <div className="flex justify-center">
                <AppContent />
            </div>
        </AppProvider>
    );
}

export default App;